const industries = () => {
  const companyIndustries = document.querySelectorAll('.js-industries');
  const popup = document.querySelector('.js-popup');
  const closeButtons = popup.querySelectorAll('.js-popup-close');

  function showPopup() {
    popup.classList.add('is-active');
  }

  function closePopup() {
    popup.classList.remove('is-active');
  }

  closeButtons.forEach(button => {
    button.addEventListener('click', event => {
      event.preventDefault();
      closePopup();
    });
  });

  function setContentInPopup(content, header) {
    const popupContent = popup.querySelector('.js-popup-content');
    const popupHeader = popup.querySelector('.js-popup-header');

    popupContent.innerHTML = content;
    popupHeader.textContent = header;
  }

  function showIndustriesInPopup(event, container) {
    event.preventDefault();
    setContentInPopup(container.innerHTML, container.dataset.popup);
    showPopup();
  }

  function checkShowButton(entries) {
    entries.forEach(item => {
      const container = item.target.closest('.js-industries');
      const button = container.querySelector('.js-industries-show');

      const containerListHeight = container.getBoundingClientRect().height;
      const industriesListHeight = item.contentRect.height;

      if (industriesListHeight > containerListHeight) {
        button.classList.remove('u-hidden');
      } else {
        button.classList.add('u-hidden');
      }

      button.addEventListener('click', event =>
        showIndustriesInPopup(event, container),
      );
    });
  }

  const resizeIndustries = new ResizeObserver(entries => {
    checkShowButton(entries);
  });

  companyIndustries.forEach(container => {
    const industriesList = container.querySelector('.js-industries-container');
    resizeIndustries.observe(industriesList);
  });
};

export default industries;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/trade-gov-chisel/src/scripts/modules/industries.js